import HTTP from '../libs/HTTP';

export interface CustomerManagerQueryParam {
    id?: number;
    name?: string;
    managerType?: number;
    states?: number;
    includeDeleted?: boolean;
}

export interface CustomerManagerListRequest {
    queryParam: CustomerManagerQueryParam;
    pageNo: number;
    pageSize: number;
}

export interface ICustomerManagerInfo {
    id: number;
    managerType: number;
    adminId?: number | null;
    adminAccount?: string | null;
    adminRole?: number | null;
    adminStates?: number | null;
    name: string;
    idCardNo?: string | null;
    residenceCity?: string | null;
    commissionMode?: string | null;
    paymentMode?: string | null;
    states: number;
    deleted?: number;
    createTime?: number;
    lastEditTime?: number;
}

export interface ICustomerManagerInfoList {
    records: ICustomerManagerInfo[];
    total: number;
    size: number;
    current: number;
    pages: number;
}

export interface CustomerManagerPostParam {
    name: string;
    idCardNo?: string;
    residenceCity?: string;
    commissionMode?: string;
    paymentMode?: string;
    states?: number;
}

export interface CustomerManagerPutParam extends CustomerManagerPostParam {
    id: number;
}

class CustomerManagerService extends HTTP {
    async getCustomerManagerList(request: CustomerManagerListRequest) {
        const response = await this.post('/customerManager/getCustomerManager', request.queryParam, {
            params: {
                pageNo: request.pageNo,
                pageSize: request.pageSize,
            },
        });
        return response ? response.data : null;
    }

    async getCustomerManagerById(id: number) {
        const response = await this.get(`/customerManager/getCustomerManagerById/${id}`);
        return response ? response.data : null;
    }

    async addExternalCustomerManager(request: CustomerManagerPostParam) {
        const response = await this.post('/customerManager/addExternalCustomerManager', request);
        return response ? response.data : null;
    }

    async updateCustomerManager(request: CustomerManagerPutParam) {
        const response = await this.put(`/customerManager/updateCustomerManager/${request.id}`, request);
        return response ? response.data : null;
    }

    async terminateCustomerManager(id: number) {
        const response = await this.put(`/customerManager/terminateCustomerManager/${id}`);
        return response ? response.data : null;
    }
}

export default new CustomerManagerService();
